export default __webpack_public_path__ + "static/media/NW0040.34I-39541_-25352_0.7baf56ed.jpg";